import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';
import { Dispatch, SetStateAction } from 'react';

interface Props {
  name: string;
  onChange: Dispatch<SetStateAction<string>>;
}

function Name({ name, onChange }: Props) {
  return (
    <div className={`mb-6`}>
      <p className="mb-2 text-sm font-semibold text-gray-800">
        <label htmlFor="name">
          <T kind="Title" />
        </label>
      </p>
      <span>
        <input
          type="text"
          id="name"
          autoComplete="off"
          maxLength={255}
          className={clsx(
            'w-full rounded-md border border-solid border-gray-300',
            'text-normal mb-1 px-4 py-2.5 text-gray-700',
          )}
          onChange={(e) => onChange(e.target.value)}
          value={name}
        />
        <p className="text-sm text-gray-500">
          <T kind="Include additional framing for the programs in this collection" />
        </p>
      </span>
    </div>
  );
}

export default observer(Name);
